import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { useCaseListQuerySchema } from "@kansai-ai-hub/schema";

import { AdminCasesListPage } from "@/features/admin/cases-list-page";
import { companyOptionsQueryOptions } from "@/features/companies/queries";
import { casesListQueryOptions, toCaseListFilters } from "@/features/cases/queries";

const searchSchema = useCaseListQuerySchema.extend({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
  view: z.enum(["grid", "table"]).default("grid"),
});

export const Route = createFileRoute("/_authenticated/admin/cases/")({
  validateSearch: searchSchema,
  // view はサーバーへ送らない UI パラメータなので deps（= queryKey）から除外する
  loaderDeps: ({ search }) => toCaseListFilters(search),
  // ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
  loader: async ({ context, deps }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(casesListQueryOptions(deps)),
      context.queryClient.ensureQueryData(companyOptionsQueryOptions("cases")),
    ]);
  },
  component: AdminCasesListPage,
});
